import React from 'react';

import type { ChatHistory, ChatHistoryEntry } from '~/components/AiChat/controller/types';
import { reportAxiosError } from '~/Utils';

/**
 * The controller's previous conversations, read again whenever `history.revision` changes. A read after the first keeps
 * the entries on screen until it lands, so the list does not blink when a new conversation joins it.
 */
export const useChatHistoryEntries = (history: ChatHistory) => {
  const { list, revision } = history;
  const [entries, setEntries] = React.useState<ChatHistoryEntry[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isError, setIsError] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;
    setIsError(false);
    list()
      .then((listed) => {
        if (!cancelled) setEntries(listed);
      })
      .catch((error) => {
        if (cancelled) return;
        setIsError(true);
        reportAxiosError(error);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [list, revision]);

  return { entries, setEntries, isLoading, isError };
};
